import { render } from "./commentoSuCliente.vue?vue&type=template&id=8121e732&ts=true"
import script from "./commentoSuCliente.vue?vue&type=script&lang=ts"
export * from "./commentoSuCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__